export default "__VITE_ASSET__BaOAstG___"